<template>
  <span>
    <img class="logo-el" src="../../assets/images/logo/logo.png" alt="">
  </span>
</template>

<script>
  export default {
  }

</script>
<style scoped>
  .logo-el {
    height: 30px;
  }
</style>
